<template>
    <b-container class="container">
      <h2 style="margin-bottom: 2rem;">Emitir Nota Fiscal</h2>
      <b-form>
        <!-- Cliente estático: veio do recebível -->
        <b-form-group v-if="$route.query.customer || $route.query.duplicate" label="Cliente" label-for="client">
          <b-form-input type="text" readonly id="client" v-model="invoice.customer.name" required></b-form-input>
        </b-form-group>
        <!-- Cliente dinâmico: será selecionado na criação da nota -->
        <b-form-group v-else label="Cliente" label-for="customer">
          <span class="info">Obrigatório</span>
          <v-select required v-model="customerPk" :reduce="item => item.value" id="customer" label="text" :options="cost_centers" />
        </b-form-group>

        <!-- Exibe o v-select de contratos apenas quando um cliente é selecionado -->
        <b-form-group v-if="customerPk && !receivablePk" label="Contratos" label-for="contracts">
          <span class="info">Opcional</span>
          <!-- Exibe o v-select com os contratos somente se estiverem carregados e existirem contratos -->
          <v-select
            v-if="!loadingContracts && $store.state.contracts.items.length > 0"
            v-model="contractPk"
            :reduce="item => item.pk"
            id="contracts"
            label="title"
            :options="$store.state.contracts.items"
          />

          <!-- Se os contratos estão sendo carregados -->
          <div v-else-if="loadingContracts">
            <span>Carregando contratos...</span>
          </div>

          <!-- Se não houver contratos disponíveis -->
          <div v-else>
            <span>Não há contratos disponíveis para este cliente.</span>
          </div>
        </b-form-group>

        <b-form-group :label="this.customer.is_pf ? 'CPF' : 'CNPJ'" label-for="cpfCnpj">
          <span class="info">Obrigatório</span>
          <b-form-input id="cpfCnpj" v-model="invoice.customer.cpf_cnpj" required v-mask="`${this.customer.is_pf ? '###.###.###-##' : '##.###.###/####-##'}`"></b-form-input>
        </b-form-group>

        <b-form-group label="E-mail para envio da cópia da nota fiscal" label-for="email">
          <span class="info">Considera-se o e-mail do financeiro. Opcional</span>
          <b-form-input type="email" id="email" v-model="invoice.customer.email"></b-form-input>
        </b-form-group>

        <!-- Endereço -->
        <b-form-group label="Endereço" label-for="address">
          <span class="info">Opcional</span>
          <b-row>
            <!-- Street -->
            <b-col sm="12" md="6">
              <b-form-input
                type="text"
                id="street"
                v-model="invoice.customer.address.street"
                placeholder="Rua, Avenida, etc."
              ></b-form-input>
            </b-col>

            <!-- Number -->
            <b-col sm="12" md="6">
              <b-form-input
                type="text"
                id="number"
                v-model="invoice.customer.address.number"
                placeholder="Número"
              ></b-form-input>
            </b-col>

            <!-- Complement -->
            <b-col sm="12" md="6">
              <b-form-input
                type="text"
                id="complement"
                v-model="invoice.customer.address.complement"
                placeholder="Complemento (Apto, Bloco, etc.)"
              ></b-form-input>
            </b-col>

            <!-- Neighborhood -->
            <b-col sm="12" md="6">
              <b-form-input
                type="text"
                id="neighborhood"
                v-model="invoice.customer.address.neighborhood"
                placeholder="Bairro"
              ></b-form-input>
            </b-col>

            <!-- UF (Estado) -->
            <b-col sm="12" md="6">
              <b-form-input
                type="text"
                id="uf"
                v-model="invoice.customer.address.uf"
                placeholder="Estado (UF)"
                maxlength="2"
              ></b-form-input>
            </b-col>

            <!-- Zip Code -->
            <b-col sm="12" md="6">
              <b-form-input
                type="text"
                id="zip_code"
                v-model="invoice.customer.address.zip_code"
                placeholder="CEP"
                maxlength="9"
                v-mask="'#####-###'"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group label="Data" label-for="date">
          <span class="info">Obrigatório</span>
          <b-form-input type="date" id="data" v-model="invoice.datetime" required></b-form-input>
        </b-form-group>
  
        <b-form-group label="Valor" label-for="value">
          <span v-if="displayExternalCurrency" class="info">Contrato com moeda externa. Coloque em reais abaixo.</span>
          <b-input-group v-if="displayExternalCurrency" :prepend="currency">
            <b-input type="number" id="value" min="0" v-model="displayExternalCurrency" disabled></b-input>
          </b-input-group>
          <p></p>
          <span class="info">Obrigatório</span>
          <b-input-group prepend="R$">
            <b-input type="text" min="0" v-model="formattedValue" required></b-input>
          </b-input-group>
        </b-form-group>
  
        <b-form-group label="Descrição" label-for="description">
          <span class="info">Obrigatório</span>
          <b-form-textarea id="description" v-model="invoice.service.description" required></b-form-textarea>
        </b-form-group>
  
        <b-button @click="issueInvoice" type="submit" style="margin-top: 1rem;" variant="primary">Emitir Nota Fiscal</b-button>
      </b-form>
  
      <div v-if="message" :class="isInvoiceSent ? 'notificacao success' : 'notificacao error'">
        <p>{{ message }} <router-link v-if="isInvoiceSent" to="/notas-fiscais">Notas Fiscais.</router-link> <span v-if="isInvoiceSent">Obs: O processamento feito pela prefeitura geralmente leva alguns minutos.</span></p>
      </div>
    </b-container>

    <!-- 
    <b-container class="container">
      <h2 style="margin-bottom: 2rem;">Ações adicionais</h2>
      <b-form-group label="Anexar Documentos" label-for="document">
        <b-form-file id="document" @change="onFileChange" multiple></b-form-file>
      </b-form-group>
    </b-container>
    -->
</template>
<script>

import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      receivablePk: null,
      receivable: {},
      customerPk: null,
      contractPk: null,
      currency: null,
      customer: {},
      customers: [],
      invoice: {
        datetime: '',
        customer: {
          name: '',
          cpf_cnpj: '',
          email: '',
          address: {
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            fu: '',
            zip_code: ''
          }
        },
        service: {
          value: 0,
          description: '',
        }
      },
      isInvoiceSent: false,
      message: '',
      loadingContracts: false,
      currency_moneys: [
        { value: 'r', text: 'Real', currency: 'R$' },
        { value: 'd', text: 'Dólar', currency: '$' },
        { value: 'e', text: 'Euro', currency: '€' },
      ],
    };
  },
  created() {
    this.receivablePk = this.$route.query.receivable
    this.customerPk = this.$route.query.customer
    this.$store.dispatch('financial/loadCostCenters');

    if (this.receivablePk) {
      this.loadCustomer()
      .then(() => {
        this.fillInvoice();
        this.loadReceivable(this.receivablePk);
      })
    }

    if (this.$route.query.duplicate) {
      const invoiceNumber = this.$route.query.duplicate
      this.getInvoice(invoiceNumber)
    }
  },
  computed: {
    formattedValue: {
      get() {
        return this.formatPrice(this.invoice.service.value || 0);
      },
      set(value) {
        // Remover tudo o que não for número (exceto ponto e vírgula)
        const numericValue = value.replace(/\D/g, ''); // Remove caracteres não numéricos
        this.invoice.service.value = numericValue ? parseInt(numericValue) : 0;
      }
    },
    cost_centers() {
      return this.$store.state.financial.cost_centers;
    },
  },  
  methods: {
    // Este método busca o contrato completo usando o contractPk
    setContractDetails(contractPk) {
      if (contractPk) {
        const selectedContract = this.$store.state.contracts.items.find(contract => contract.pk === contractPk);
        this.contract = selectedContract || null; // Atribui o contrato ou null se não encontrado
        if (this.contract) {
          this.currency = this.appendCurrency();
          if (this.currency != "R$") {
            this.displayExternalCurrency = this.contract.versions[0].value
          } else {
            this.invoice.service.value = this.contract.versions[0].value
          }
        }
      } else {
        this.contract = null;  // Se não houver contractPk selecionado, reseta as informações do contrato
      }
    },
    appendCurrency() {
      const item = this.currency_moneys.find(currency => currency.value === this.contract.currency_money);
      return item ? item.currency : null;
    },
    loadContracts() {
      if (this.customerPk) {
        this.loadingContracts = true;  // Inicia o carregamento dos contratos
        
        try {
          // Aqui você faz a requisição para buscar os contratos do cliente selecionado
          this.$store.dispatch('contracts/loadItems', {
            customer_pk: this.customerPk,
          }).then(() => {
            this.loadingContracts = false; // Finaliza o carregamento
          }).finally(() => {
            this.loadingContracts = false;  // Finaliza o carregamento dos contratos
          })
        } catch (error) {
          this.$snotify.error('Erro ao carregar os contratos. Tente novamente.', 'Erro', {
            timeout: 0,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true
          })
          this.loadContracts = false;
        }

        // Reseta o contrato selecionado para evitar inconsistências
        this.contractPk = null;
      }
    },
    getInvoice(invoicePk) {
      axios.post(`/financial/invoices/${invoicePk}/`)
      .then((response) => {
        const invoice = response.data;
        this.fillInvoice(invoice);
        this.customerPk = invoice.customer.pk
      })
    },
    loadReceivable(pk) {
      // Endpoint que retorna informações de um único recebível, pelo pk
      axios.post(`/financial/receivable/${pk}/`)
      .then((response) => {
        const receivable = response.data
        this.invoice.service.value = receivable.total_value
      })
    }, 
    async loadCustomer() {
        const response = await this.$store.dispatch('customers/getCustomer', this.customerPk);
        this.customer = response;

        const financial_contact_email = await axios.post('/crm/customers/contact/' + this.customerPk + '/get_financial_contact/')
        this.customer.financial_contact_email = financial_contact_email.data.data.email
    },
    fillInvoice(invoice=null) {
      if (invoice) {
        this.invoice.customer.name = invoice.customer.name
        this.invoice.customer.cpf_cnpj = invoice.customer.cpf_cnpj
        this.invoice.customer.email = invoice.customer.email
        this.invoice.customer.address.street = invoice.customer.address.street;
        this.invoice.customer.address.number = invoice.customer.address.number;
        this.invoice.customer.address.complement = invoice.customer.address.complement;
        this.invoice.customer.address.neighborhood = invoice.customer.address.neighborhood;
        this.invoice.customer.address.uf = invoice.customer.address.uf;
        this.invoice.customer.address.zip_code = invoice.customer.address.zip_code;
        this.invoice.service.value = invoice.service.value
        this.invoice.service.description = invoice.service.description
      } else {
        this.invoice.customer.name = this.getCustomerName(this.customer);
        this.invoice.customer.cpf_cnpj = this.getCustomerDocument(this.customer)
        this.invoice.customer.email = this.customer.financial_contact_email
        this.invoice.customer.address.street = this.customer.address;
        this.invoice.customer.address.number = this.customer.address_number;
        this.invoice.customer.address.complement = this.customer.complement;
        this.invoice.customer.address.neighborhood = this.customer.district;
        this.invoice.customer.address.uf = this.customer.uf;
        this.invoice.customer.address.zip_code = this.customer.cep;
      }
    },
    getCustomerName(customer) {
      return customer.social_name ? customer.social_name : customer.name
    },
    getCustomerDocument(customer) {
      if (customer.is_pf) {
        return this.formatCPF(customer.cpf);
      } else {
        return this.formatCNPJ(customer.cnpj);
      }
    },
    onFileChange(event) {
      const files = event.target.files;
      this.invoice.documents = Array.from(files);
    },
    async issueInvoice(event) {
      event.preventDefault();

      // Obtém o formulário (se você estiver usando o elemento <form>)
      const form = event.target.closest('form');
  
      // Verifica se o formulário é válido (faz a validação personalizada)
      const formElements = form.elements;
      let isValid = true;

      // Itera sobre os campos do formulário e valida apenas os obrigatórios
      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];
        if (element.required && !element.checkValidity()) {
          isValid = false;
          break;
        }
      }

      if (!isValid) {
        // Caso o formulário não seja válido, evita o envio e mostra uma mensagem ou algo
        this.isInvoiceSent = false;
        this.message = 'Por favor, preencha todos os campos obrigatórios.';
        return;
      }

      // Formata o valor da nota para enviar de maneira correta para o backend
      const value = this.formatInvoiceValueForBackend(this.formattedValue)

      const invoice = {
        datetime: this.invoice.datetime,
        customer: {
          pk: this.customerPk,
        },
        service: {
          value: value,
          description: this.invoice.service.description,
        },
        email: this.invoice.customer.email,
        receivable_pk: this.receivablePk,
        contract_pk: this.contractPk
      }

      let bodyFormData = new FormData();
      bodyFormData.append('obj', JSON.stringify(invoice));
      await axios.post('/financial/invoices/issue_invoice/', bodyFormData)
      .then(response => {
        const status = response.data.status
        const invoiceSentToProcessing = status == "processando_autorizacao"

        if (invoiceSentToProcessing) {
          this.$snotify.success('Nota fiscal enviada para processamento.', 'Em Processamento', {
            timeout: 4000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true
          });
          this.isInvoiceSent = true;
          this.message = `A nota referente aos serviços prestados para ${this.customer.social_name} foi enviada para processamento com sucesso. Acompanhe seu status na página de `  
        } else {
          this.isInvoiceSent = false;

          switch (request.status) {
            case 'requisicao_invalida':
              this.message = 'Alguns parâmetros básicos não foram cumpridos. Verifique os dados enviados e tente novamente.';
              break;
            case 'certificado_vencido':
              this.message = 'O certificado digital do emitente está vencido. Atualize o certificado e tente novamente.';
              break;
            case 'nfe_autorizada':
              this.message = 'A nota fiscal já foi autorizada e não pode ser reenviada para processamento.';
              break;
            default:
              this.message = 'Ocorreu um erro desconhecido ao enviar a nota para processamento. Tente novamente mais tarde.';
              break;
          }
        }
      })
      .catch(error => {
        console.log(JSON.stringify(error))
        console.log(error)
        this.$snotify.error('Um erro inesperado aconteceu ao emitir a nota fiscal. Verifique todos os campos e tente novamente. Se precisar, fale com o suporte.', 'Erro', {
        timeout: 0,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true
      });
      });

    // Se a resposta contiver um número de nota fiscal ou algum identificador
      // Limpa o formulário após a criação
      /* this.invoice = {
        client: {
          name: '',
          cpfCnpj: '',
          email: '',
          address: {
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            fu: '',
            zip_code: '',
          }
        },
        date: '',
        value: '',
        description: '',
        documents: []
      };*/
    },
    formatInvoiceValueForBackend(value) {
      // Garantir que o valor seja uma string, caso contrário, transforma para string
      let rawValue = value.toString();

      // Substitui a vírgula por ponto, se houver (para lidar com valores como "14,56")
      rawValue = rawValue.replace(',', '.');

      // Remove pontos de milhar (ex: "1.000,56" para "1000.56")
      rawValue = rawValue.replace(/\.(?=\d{3,})/g, '');

      // Retorna o valor como número decimal
      return parseFloat(rawValue) || 0;
    },
    formatPrice(value) {
      // Garantir que o valor seja uma string
      let strValue = value.toString();

      // Se o valor for numérico com ponto (ex: 1700.00), tratar corretamente
      if (strValue.includes('.')) {
        strValue = strValue.replace('.', ''); // Remover ponto do número decimal
      }

      // Adicionar zeros à esquerda se o valor tiver menos de 2 dígitos
      const padValue = strValue.padStart(2, '0');

      // Separar a parte inteira e a parte decimal
      let integerPart = padValue.slice(0, -2);
      let decimalPart = padValue.slice(-2);

      // Se a parte inteira estiver vazia (para o valor zero), garantir que seja '00'
      integerPart = integerPart || '00';

      // Adicionar pontos a cada 3 dígitos na parte inteira
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      // Concatenar a parte inteira com a parte decimal e retornar a formatação completa
      return `${integerPart},${decimalPart}`;
    },
    formatCPF(cpf) {
      // Remove todos os caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');
      
      // Aplica o formato com pontos e traço
      if (cpf.length === 11) {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }
      
      // Se o CPF não tiver 11 dígitos, retorna o próprio número (não formatado)
      return cpf;
    },
    formatCNPJ(cnpj) {
      // Remove todos os caracteres não numéricos
      cnpj = cnpj.replace(/\D/g, '');
      
      // Aplica o formato com pontos, barra e traço
      if (cnpj.length === 14) {
        return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      
      // Se o CNPJ não tiver 14 dígitos, retorna o próprio número (não formatado)
      return cnpj;
    }
  },
  watch: {
    // Observa mudanças no contractPk (quando um contrato for selecionado)
    contractPk(newValue) {
      this.setContractDetails(newValue);
    },
    customerPk(newValue) {
      if (!this.customerPk) {
        return
      }

      if (newValue && !this.$route.query.duplicate) {
        this.invoice.service.value = 0;
        this.loadContracts();
      }

      this.loadCustomer()
      .then(() => {
        this.invoice.customer.cpf_cnpj = this.getCustomerDocument(this.customer)
        this.invoice.customer.email = this.customer.financial_contact_email
        this.invoice.customer.address.street = this.customer.address;
        this.invoice.customer.address.number = this.customer.address_number;
        this.invoice.customer.address.complement = this.customer.complement;
        this.invoice.customer.address.neighborhood = this.customer.district;
        this.invoice.customer.address.uf = this.customer.uf;
        this.invoice.customer.address.zip_code = this.customer.cep;
      })
    }
  }
};
</script>

<style scoped>
  .notificacao {
    background-color: #f8f9fa;
    border: 1px solid #ccc;
    padding: 10px;
    margin: 10px 0;
    margin-top: 2rem;
    border-radius: 4px;
  }
  .notificacao a {
    color: #007bff;
  }
  .success {
    background-color: hsl(139, 100%, 81%) !important;
  }
  .error {
    background-color: hwb(0 62% 0%) !important;
  }
  .info {
    font-size: 12px;
    color: gray;
    display: block;
    margin-top: -0.55rem;
    margin-bottom: 0.5rem;
  }
  .container {
      background: white !important;
      padding: 2rem !important;
      margin-top: 2rem !important;
      margin-bottom: 2rem !important;
  }
</style>